import { LanguageCode } from "../types";

const en = {
  languageCode: "en" as LanguageCode,

  users: {
    add: "Add user",
    all: "All users",
    edit: "Edit user",
    plural: "Users",
    remove: "Remove user",
    search: "Search users",
    usersEmail: "Users email",
    usersName: "Users name",

    questions: {},

    errors: {
      notFound: "User not found.",
    },
  },

  clients: {
    all: "All clients",
    plural: "Clients",
    createNew: "Create new client",
    delete: "Delete client",
    search: "Search clients",

    questions: {
      delete: "Do you really want to delete this client?",
    },

    errors: {
      notFound: "Client not found.",
      missingName: "Client name is missing.",
      insertNotAllowed: "You are not allowed to insert a new client.",
      readNotAllowed: "You are not allowed to read this client.",
      updateNotAllowed: "You are not allowed to update this client.",
      deleteNotAllowed: "You are not allowed to delete this client.",
    },
  },

  roles: {
    plural: "Roles",
  },

  permissions: {
    plural: "Permissions",
  },

  secrets: {
    plural: "Secrets",

    errors: {
      missingName: "Secret name is missing.",
      missingValue: "Secret value is missing.",
    },
  },

  common: {
    administration: "Administration",
    author: "Author",
    cancel: "Cancel",
    createNew: "Create new",
    dataHasBeenSavedSuccessfully: "Data has been saved succesfully.",
    date: "Date",
    delete: "Delete",
    edit: "Edit",
    email: "Email",
    error: "Error",
    errorLoadingData: "Error loading data",
    exportExcel: "Export Excel",
    fieldCannotBeEmpty: "The field cannot be empty.",
    fieldContainsInvalidValueInsertBiggerOne: "The field contains an invalid value, insert a bigger one.",
    fieldContainsInvalidValueInsertSmallerOne: "The field contains an invalid value, insert a smaller one.",
    fieldValueInvalidFormat: "The value has an invalid format.",
    fieldInvalidValue: "The field contains an invalid value.",
    firstName: "First name",
    forbidden: "Forbidden",
    genericError: "An error has occurred, please try again.",
    hi: "Hi",
    hoursPerProject: "Hours per project",
    home: "Home",
    issue: "Issue",
    lastName: "Last name",
    loadData: "Load data",
    loading: "Loading...",
    name: "Name",
    nextNRows: (n: number) => `Next ${n} rows`,
    nextPage: "Next page",
    noItemsFound: "No items found",
    notFound: "Not found",
    number: "Number",
    optional: "optional",
    pageNotFound: "Page not found",
    previousNRows: (n: number) => `Previous ${n} rows`,
    prevPage: "Prev page",
    projectsOverview: "Projects overview",
    reports: "Reports",
    resourceNotFound: "The resource you are looking for has not been found.",
    save: "Save",
    search: "Search",
    time: "Time",
    weeklyReport: "Weekly Report",
    worklogs: "Worklogs",
    yes: "Yes",
    youAreNotAllowed: "You are not allowed to access this resource.",
  },
};

export default en;
